import { useCallback, useEffect, useMemo, useState } from 'react'
import { Form, Table } from 'react-bootstrap'
import Navbar from '../../components/navbar/navbar'
import LeroyMerlinService from '../../services/database/LeroyMerlinService'

import leroyMerlinSvg from '../../assets/leroy-merlin.svg'
import { CustomSpinner } from '../../components/CustomSpinner'

import noOrdersIllustration from './assets/no-orders.gif'

import { Order } from './Order'

import { compareDesc, parseISO } from 'date-fns'
import ReactPaginate from 'react-paginate'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import './styles.css'

export function ImportarPedidosLeroy() {
  const [accounts, setAccounts] = useState([])
  const [selectedAccountToken, setSelectedAccountToken] = useState('')
  const [orders, setOrders] = useState([])
  const [isOrdersLoading, setIsOrdersLoading] = useState(false)

  const [search, setSearch] = useState('')
  const [type, setType] = useState('order_id')

  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const [itemsPerPage, _] = useState(50)

  const endOffset = itemOffset + itemsPerPage

  const sortedOrders = useMemo(() => {
    setPageCount(Math.ceil(orders.length / itemsPerPage))

    return orders
      .filter((order) =>
        String(order[type])
          .toLowerCase()
          .includes(String(search).toLowerCase()),
      )
      .slice(itemOffset, endOffset)
  }, [endOffset, itemOffset, itemsPerPage, orders, search, type])

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % orders.length

    setItemOffset(newOffset)
  }

  const fetchOrders = useCallback(async () => {
    setIsOrdersLoading(true)

    try {
      const data = await LeroyMerlinService.getOrders(selectedAccountToken)

      setOrders(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar os pedidos!')
    } finally {
      setIsOrdersLoading(false)
    }
  }, [selectedAccountToken])

  async function fetchAccounts() {
    try {
      const data = await LeroyMerlinService.getAccounts()

      setAccounts(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível listar as contas!')
    }
  }

  useEffect(() => {
    if (selectedAccountToken) {
      fetchOrders()
    }
  }, [fetchOrders, selectedAccountToken])

  useEffect(() => {
    fetchAccounts()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page container">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
          }}
        >
          <img
            src={leroyMerlinSvg}
            alt=""
            style={{
              width: 85,
              height: 85,
            }}
          />

          <h1
            style={{
              margin: 0,
            }}
          >
            Importação de Pedidos
          </h1>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <article
            style={{
              display: 'flex',
              alignItems: 'flex-end',
            }}
          >
            <div>
              <Form.Label>Conta:</Form.Label>

              <Form.Select
                defaultValue=""
                onChange={(e) => setSelectedAccountToken(e.target.value)}
                style={{
                  width: 400,
                }}
              >
                <option value="">Selecione uma conta</option>
                {accounts.map((account) => (
                  <option
                    key={account.TOKEN}
                    value={account.TOKEN}
                  >
                    {account.NOME_CONTA}
                  </option>
                ))}
              </Form.Select>
            </div>
          </article>

          <article
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              gap: 10,
            }}
          >
            <div>
              <Form.Label>Tipo de pesquisa:</Form.Label>

              <Form.Select
                defaultValue={type}
                onChange={(e) => setType(e.target.value)}
                style={{
                  width: 400,
                }}
              >
                <option value="order_id">ID</option>
                <option value="customer_name">Cliente</option>
              </Form.Select>
            </div>

            <div>
              <Form.Label>Pesquisa:</Form.Label>

              <Form.Control
                placeholder="Digite..."
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                style={{
                  width: 400,
                }}
              />
            </div>
          </article>
        </div>

        <main className="leroy-import-content">
          {!isOrdersLoading && orders.length === 0 && (
            <img
              src={noOrdersIllustration}
              style={{
                width: 400,
              }}
            />
          )}

          {isOrdersLoading ? (
            <CustomSpinner color="#72bf44" />
          ) : (
            orders.length > 0 && (
              <div
                style={{
                  width: '100vw',
                }}
              >
                <Table
                  striped
                  bordered
                  hover
                  responsive
                >
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Cliente</th>
                      <th>Data</th>
                      <th>Valor</th>
                      <th>Status</th>
                      <th>Ação</th>
                      <th>Importado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedOrders
                      .sort((a, b) => {
                        if (!a.date && !b.date) {
                          return 0
                        }
                        if (!a.date) {
                          return 1
                        }
                        if (!b.date) {
                          return -1
                        }
                        return compareDesc(parseISO(a.date), parseISO(b.date))
                      })
                      .map((order) => (
                        <Order
                          key={order.order_id}
                          order={order}
                          selectedAccountToken={selectedAccountToken}
                          fetchOrders={fetchOrders}
                        />
                      ))}
                  </tbody>
                </Table>

                <ReactPaginate
                  breakLabel="..."
                  nextLabel="Próxima"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  previousLabel="Anterior"
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  activeClassName="active"
                />
              </div>
            )
          )}
        </main>
      </div>
    </>
  )
}
